import { configure } from 'scrivito'

import { scrivitoTenantId } from './scrivitoTenants'
import { INSTANCE_APP_ROUTE_PATH } from '@/const'
import { getInstanceIdFromUrl } from '@/utils/getInstanceIdFromUrl'

export function configureScrivito(options?: { priority?: 'background' }) {
  const accountRootPath = `${INSTANCE_APP_ROUTE_PATH}/${getInstanceIdFromUrl()}`
  const tenantID = import.meta.env.VITE_SCRIVITO_MAIN_TENANT_ID

  if (!tenantID) throw Error('Could not determine main tenant ID')

  configure({
    adoptUi: true,
    autoConvertAttributes: true,
    contentTagsForEmptyAttributes: false,
    extensionsUrl: `/_scrivito_extensions.html?tenantId=${scrivitoTenantId()}`,
    optimizedWidgetLoading: true,
    strictSearchOperators: true,
    tenant: tenantID,
    // @ts-expect-error // TODO: Remove later on
    unstable: {
      trustedUiOrigins: [
        'http://localhost:8090',
        'https://*.scrivito-ui.pages.dev',
      ],
    },
    routingBasePath:
      typeof window !== 'undefined' &&
      window.location.pathname.startsWith(accountRootPath)
        ? accountRootPath
        : undefined,
    treatLocalhostLike: 'https://crm.justrelate.com',
    ...options,
  })
}
